export default __webpack_public_path__ + "static/media/leftArrow.b959b60b.svg";